// extracted by mini-css-extract-plugin
module.exports = {"section_partner":"partner_section_partner__NRlTi","sub_title":"partner_sub_title__8_PX7","image_wrapper":"partner_image_wrapper__etNtK"};